export default "__VITE_ASSET__BhW87FFc__"